module.exports = __webpack_public_path__ + "static/media/10_l_derevo_0_71.94.4d3366e2.png";